/* eslint-disable */
import wrapWithProvider from './wrap-with-provider';
import './src/styles/pages/index.scss';

export const wrapRootElement = wrapWithProvider;
